import React, { useState } from 'react'
import {
	DownloadIcon,
	ExitCrossIcon,
	ReGeneratedIcon,
	RightArrowIcon,
	SaveIcon,
} from '../icons'

export const GeneratedPosts: React.FC = () => {
	const [isRegentratingPosts, setIsRegentratingPosts] = useState<boolean>(false)
	return (
		<div className='generated-posts'>
			<div className='rows'>
				<div className='first-row'>
					<section className='content'>
						<h1>Generated Posts</h1>
						<p>ADYOUNEED Branding</p>
					</section>
					<section className='buttons'>
						<button>
							<ExitCrossIcon /> Dıscard anD exıt
						</button>
						<button>
							<SaveIcon /> Save anD exıt
						</button>
						<button>
							<DownloadIcon /> DOWNLOAD SELECTED
						</button>
					</section>
				</div>
				<div className='second-row'>
					{isRegentratingPosts ? (
						<section className='upper-text-buttons'>
							<section className='select-section'>
								<select placeholder='Choose a Font'>
									<option>Choose a Font</option>
									<option>Ping Pong</option>
									<option>Ting Tong</option>
								</select>
							</section>
							<button>
								<ReGeneratedIcon />
								RE-GENERATE
								<RightArrowIcon />
							</button>
						</section>
					) : (
						<section className='upper-text'>
							<ReGeneratedIcon />
							<p onClick={() => setIsRegentratingPosts(true)}>
								I want to re-generate with different fonts.
							</p>
						</section>
					)}
					<section className='cards-grid'>
						{imagesURL.map((pic, i) => (
							<section className='card'>
								<img src={pic} alt='img' />
								<section className='card-specs'>
									<div className='checkbox'>
										<input type='checkbox' name='my-checkbox' id={pic + i} />
										<label htmlFor={pic + i}>
											<p>Select</p>
										</label>
									</div>
									<div className='download'>
										<h3>Download</h3>
										<DownloadIcon />
									</div>
								</section>
							</section>
						))}
					</section>
				</div>
			</div>
		</div>
	)
}

const imagesURL = [
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
]
